// Validates if a string is a valid email address
function isValidEmail(email) {
	// Simple regex for email validation
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
}

module.exports = {
	isValidEmail
};
